import { AddOnsCombineSetup } from "../../../../components/AddOns/Accounting/AddOnsCombineSetup";
import { AuthenticatedLayout } from "../../../../layouts";
import DescriptionOutlinedIcon from "@mui/icons-material/DescriptionOutlined";

export const AddOnsCombineSetupPage = () => {
  return (
    <AuthenticatedLayout
      pageTitle="Setup"
      pageTitleIcon={<DescriptionOutlinedIcon />}
      breadcrumbCurrentPageName=""
      mainContents={<AddOnsCombineSetup />}
    />
  );
};
